import { render, staticRenderFns } from "./techProcessesAddWasteForm.vue?vue&type=template&id=72d78639&"
import script from "./techProcessesAddWasteForm.vue?vue&type=script&lang=js&"
export * from "./techProcessesAddWasteForm.vue?vue&type=script&lang=js&"
import style0 from "./techProcessesAddWasteForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports